import { supabase, getUid } from "./supabase";
import { enqueue } from "./outbox";
import { cacheGet, cacheSet } from "./dataCache";

/* Speed-count drill persistence (Pro). recordSpeed is is_pro-gated; getSpeedDaily
   reads the caller's own rollup. Best-effort from the UI. */

/* DELIBERATE device-local day key — see the note in drillStats.js. */
const localDay = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export async function recordSpeedRaw(system, cpm, correct, day) {
  const { error } = await supabase.rpc("speed_record", {
    p_system: system,
    p_cpm: Math.round(cpm),
    p_correct: !!correct,
    p_day: day,
  });
  if (error) {
    console.warn("speed_record failed:", error.message);
    return false;
  }
  return true;
}

export async function recordSpeed(system, cpm, correct) {
  const day = localDay();
  const ok = await recordSpeedRaw(system, cpm, correct, day);
  if (!ok) enqueue({ kind: "speed", payload: { system, cpm: Math.round(cpm), correct: !!correct, day } });
  return { ok };
}

export async function getSpeedDaily(system) {
  const uid = await getUid();
  if (!uid) return [];
  let q = supabase
    .from("speed_daily")
    .select("system, day, runs, correct, best_cpm, sum_cpm")
    .eq("user_id", uid);
  if (system && system !== "All") q = q.eq("system", system);
  const key = `speedDaily:${uid}:${system ?? "All"}`;
  const { data, error } = await q.order("day", { ascending: true });
  if (error) {
    console.warn("speed_daily fetch failed:", error.message);
    return cacheGet(key) ?? null; // never-cached error → null (≠ empty)
  }
  cacheSet(key, data ?? []);
  return data ?? [];
}
